import React from "react";
import { useTranslation } from "react-i18next";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { TextBlock } from "src/components/Typography/TextBlock";
import { TERMS_OF_USE_BLOCKS } from "src/page-components/terms-of-use/constants";
import { termsOfUseTrns } from "src/page-components/terms-of-use/trns";

const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <MetadataWrapper name="terms_and_disclaimer">
      <PageWrapper mainClassName="flex flex-col mt-19">
        <div className="container py-20">
          <h1 className="text-28 font-semibold">{t(termsOfUseTrns.title)}</h1>
          <h2 className="text-xl font-semibold font-steppe my-10">
            {t(termsOfUseTrns.effectiveDate)}
          </h2>
          <div className="max-w-200 flex flex-col gap-7">
            {TERMS_OF_USE_BLOCKS.map((block) => (
              <TextBlock key={block.id} {...block} />
            ))}
          </div>
        </div>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default TermsOfUse;
